import { Box, Container, Typography } from '@mui/material'
import theme from '@rfh-core/theme'

import ClocksStatusGrid from './ClocksStatusGrid'

export default function ClocksStatus(): JSX.Element {
  return (
    <Container maxWidth={'sm'}>
      <Box textAlign='center' pt={0} mt={0}>
        <Typography
          aria-label={'Logistics Dashboard'}
          variant={'h2'}
          sx={{ color: theme.rfhColors.leafGreen, mb: '0.5em', mt: 0, p: 0 }}
        >
          {'Klokkenstatus'}
        </Typography>
      </Box>
      <ClocksStatusGrid />
    </Container>
  )
}
